// extracted by mini-css-extract-plugin
export default {"root":"_2sDqj","expanded":"_2aBKN"};